// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ISizeF {
	isEmpty: boolean;

	width: number;

	height: number;

	$type?: string | undefined;
}
export class SizeF {
	constructor(data?: ISizeF) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	isEmpty: boolean = false;

	width: number = 0;

	height: number = 0;

	static $type: string = "Shared.Geometry.SizeF, ";
	$type?: string | undefined = SizeF.$type;
}

